export type ThreadScrollTarget = 'focus' | 'end' | 'preserve'

/** Position at a requested message once, then resume following appended chat. */
export function pickThreadScrollTarget({
  focusId,
  hasFocusMessage,
  focusedMessageId,
  focusedMessageLength,
  messageLength,
}: {
  focusId: string | undefined
  hasFocusMessage: boolean
  focusedMessageId: string | null
  focusedMessageLength: number | null
  messageLength: number
}): ThreadScrollTarget {
  if (!focusId || !hasFocusMessage) return 'end'
  if (focusedMessageId !== focusId || focusedMessageLength === null) return 'focus'
  if (messageLength > focusedMessageLength) return 'end'
  return 'preserve'
}
